// extracted by mini-css-extract-plugin
export default {"list":"List_list__DrYFp","list_play":"List_list_play__zQ5DO","list_video":"List_list_video__I9gzx"};